import { Injectable } from '@angular/core';
import { Item, Field } from '@sitecore-jss/sitecore-jss/layout';

@Injectable({
  providedIn: 'root'
})
export class GetItemListFieldsService {
  constructor() {}

  getFields(metadata: Item): { [key: string]: { [name: string]: Field } } {
    if (!metadata) {
      return;
    }

    const labels: { [key: string]: { [name: string]: Field } } = {};
    (metadata.fields.items as Item[]).forEach(item => {
      labels[this.getKey(item)] = item.fields as { [name: string]: Field };
    });

    return labels;
  }

  getItems(data: Item[]): { [key: string]: Item } {
    const items: { [key: string]: Item } = {};

    data.forEach(item => {
      items[this.getKey(item)] = item;
    });

    return items;
  }

  private getKey(item: Item) {
    let key = item.name.split(' ').join('');
    key = key.charAt(0).toLocaleLowerCase() + key.slice(1);

    return key;
  }
}
